module.exports = __webpack_public_path__ + "static/media/abstrato-3.bbe2df4b.jpg";